import { createFileRoute } from "@tanstack/react-router"
import { AppShell } from "../components/layout/app-shell"
import { QueryState } from "../components/layout/query-state"
import { SearchRankingFreshness } from "../components/search-rankings/search-ranking-freshness"
import { SearchRankingMarketplaceSwitch } from "../components/search-rankings/search-ranking-marketplace-switch"
import { SearchRankingView } from "../components/search-rankings/search-ranking-view"
import { useSearchRankingOverview } from "../services/use-search-rankings"

function SearchRankingPage() {
  const { marketplace } = Route.useParams()
  const overview = useSearchRankingOverview(marketplace)
  return (
    <AppShell
      title="Keywords"
      actions={
        <>
          <SearchRankingMarketplaceSwitch marketplace={marketplace} />

          {overview.data ? (
            <SearchRankingFreshness
              latestRun={overview.data.latestRun}
              timeZone={overview.data.marketplace.reportingTimeZone}
            />
          ) : null}
        </>
      }
    >
      <QueryState
        isLoading={overview.isLoading}
        error={overview.error}
        isEmpty={overview.data === undefined}
        emptyMessage="No keyword data yet."
      >
        {overview.data ? (
          <SearchRankingView
            marketplace={overview.data.marketplace}
            keywords={overview.data.keywords}
          />
        ) : null}
      </QueryState>
    </AppShell>
  )
}

export const Route = createFileRoute("/keywords/$marketplace/")({ component: SearchRankingPage })
